/* eslint-disable */
import InfoModal from 'components/InfoModal/InfoModal';
import './ModalFormularioActaInicio.scss';
import { useEffect, useMemo, useState } from 'react';
import PropTypes, { number } from 'prop-types';
import { Form, Row, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, LoadingCard, Accordion, EstatusFormulario } from 'components';
import {
  newScrollToErrorField,
  encontrarActiveKeyPorValor
} from 'utils/form/newScrollToErrorField';
import { PROCESOS_ELECTORALES } from 'constants/nombresCatalogos';
import {
  selectCatalogByName,
  selectfirmanteByUsuario,
  selectCatalogs
} from 'selectors/catalogos.selectors';
import {
  formatCreateNewActaInicio,
  formatEditActaInicio,
  formatFromBackToFormActaInicio
} from 'adapters/formatoMonitoreoEspectaculares';
import { selectAuthState } from 'selectors/auth.selector';
import { upsertEspectacularesActaInicio } from 'actions/espectaculares.actions';
import { useLocation, useNavigate } from 'react-router-dom';
import * as fieldMsgs from 'constants/formFieldsMessages';
import DatosGenerales from './components/DatosGenerales/DatosGenerales';
import Ubicacion from './components/Ubicacion/Ubicacion';
import VialidadesRecorridas from './components/VialidadesRecorridas/VialidadesRecorridas';
import Hechos from './components/Hechos/Hechos';
import ServidoresPublicos from './components/ServidoresPublicos/ServidoresPublicos';
import ServidoresPublicosJuntaLocal from './components/ServidoresPublicosJuntaLocal/ServidoresPublicosJuntaLocal';
import RepresentantesSujetosObligados from './components/RepresentantesSujetosObligados/RepresentantesSujetosObligados';
import ModalCodigoQR from './components/ModalCodigoQR/ModalCodigoQR';
import ModalFormularioActaCierre from '../../../MonitoreoActaCierre/components/ModalFormularioActaCierre/ModalFormularioActaCierre';

const identificadoresForm = {
  datosGenerales: ['procesoEspecificoId', 'horaInicial', 'horaFinal'],
  ubicacion: [
    'estadoId',
    'distritoFedId',
    'municipioId',
    'calle',
    'numeroExterior',
    'colonia',
    'codigoPostal',
    'referencias'
  ],
  vialidadesRecorridas: ['recorrido']
};

const ModalFormularioActaInicio = ({
  onClose,
  visible,
  initialData,
  loadingImages,
  filtroFolioActaInicio,
  pagina,
  pageSize
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formActaInicio] = Form.useForm();
  const dispatch = useDispatch();
  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);
  const [visibleFormModalActaCierre, setVisibleFormModalActaCierre] = useState(false);
  const [visibleModalQR, setVisibleModalQR] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [reasonCancel, setReasonCancel] = useState(false);
  const [activeKey, setActiveKey] = useState([]);
  const [dataQR, setDataQR] = useState({});
  const [dataFromQR, setDataFromQR] = useState(null);
  const { data } = useSelector(selectAuthState);

  const usuarioId = useSelector(selectfirmanteByUsuario(data.name));
  const catalogos = useSelector(selectCatalogs);
  const procesosCat = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));
  const procesosElectorales = procesosCat.map((proceso) => ({
    ...proceso,
    nombreProcesoEspecifico: proceso?.nombreProcesoEspecifico?.replace('Ã±', 'ñ')
  }));

  const clearQueryParam = (param) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete(param);
    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString()
      },
      { replace: true }
    );
  };

  const handleCancel = () => {
    onClose?.();
    setActiveKey([]);
    formActaInicio.resetFields();
  };

  const handleCloseModalActaCierre = () => {
    setVisibleFormModalActaCierre(false);
  };

  const handleDataFromQR = (dataFrom) => {
    setDataFromQR(dataFrom);
  };

  const handleCollapseChange = (key) => {
    setActiveKey(key);
  };

  const handleOK = async () => 
  {
    setIsLoading(true);
    try 
    {
      const values = await formActaInicio.validateFields();
      const payload = initialData
        ? formatEditActaInicio(values, catalogos, initialData)
        : formatCreateNewActaInicio(values, catalogos);
      const {
        success,
        monitoreo: { synced }
      } = await dispatch(upsertEspectacularesActaInicio(payload, pagina, pageSize));
      if (success && !initialData) 
      {
        const prevDataQR = {
          ...payload.monitoreos.toSave[0],
          folio: synced[0].folio,
          idMonitoreo: synced[0].id,
          id: synced[0].actas[0].id,
          idUsuario: usuarioId,
          userName: data.name
        };
        setDataQR(prevDataQR);
        setVisibleModalQR(true);
        onClose?.();
        setActiveKey([]);
        formActaInicio.resetFields();
      } else if (filtroFolioActaInicio) 
      {
        clearQueryParam('folio');
        setIsVisibleSuccessModal(true);
        onClose?.();
        setActiveKey([]);
        formActaInicio.resetFields();
      } else 
      {
        setIsVisibleSuccessModal(true);
        onClose?.();
        setActiveKey([]);
        formActaInicio.resetFields();
      }
    } catch (error) 
    {
      const { errorFields } = error;
      if (errorFields) 
      {
        const [firstError] = errorFields;
        const identifierForm = encontrarActiveKeyPorValor(
          identificadoresForm,
          firstError?.name?.[0]
        );
        if (identifierForm) 
        {
          newScrollToErrorField(errorFields, formActaInicio);
          setActiveKey([`${identifierForm}`]);
        } else {
          setActiveKey([`${newScrollToErrorField(errorFields, formActaInicio)}`]);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const items = useMemo(() => [
    {
      key: 'datosGenerales',
      label: 'Datos generales',
      forceRender: true,
      children: (
        <DatosGenerales
          form={formActaInicio}
          folio={initialData?.tableRow?.actas[0]?.folioMonitoreo}
        />
      )
    },
    {
      key: 'ubicacion',
      label: 'Ubicación',
      forceRender: true,
      children: (
        <Ubicacion form={formActaInicio} folio={initialData?.tableRow?.actas[0]?.folioMonitoreo} />
      )
    },
    {
      key: 'fiscalizacion',
      label: 'Servidores públicos',
      forceRender: true,
      children: (
        <ServidoresPublicos
          form={formActaInicio}
          loadingImages={loadingImages}
          servidores={initialData?.tableRow?.actas[0]?.fiscalizacion}
        />
      )
    },
    {
      key: 'juntaLocalDistrital',
      label: 'Servidores públicos de Junta Local (Opcional)',
      forceRender: true,
      children: <ServidoresPublicosJuntaLocal form={formActaInicio} loadingImages={loadingImages} />
    },
    {
      key: 'vialidadesRecorridas',
      label: 'Vialidades a recorrer',
      forceRender: true,
      children: <VialidadesRecorridas form={formActaInicio} />
    },
    {
      key: 'sujetosObligados',
      label: 'Representantes de Sujetos Obligados (Opcional)',
      forceRender: true,
      children: (
        <RepresentantesSujetosObligados
          form={formActaInicio}
          folio={initialData?.tableRow?.actas[0]?.folioMonitoreo}
          loadingImages={loadingImages}
        />
      )
    },
    {
      key: 'hechos',
      label: 'Hechos (Opcional)',
      forceRender: true,
      children: <Hechos form={formActaInicio} />
    }
  ]);

  useEffect(() => {
    if (initialData?.tableRow) {
      const formatedActaInicio = formatFromBackToFormActaInicio(initialData.tableRow);
      formActaInicio.setFieldsValue(formatedActaInicio);
      if (formatedActaInicio.motivoCancelacion) {
        setReasonCancel(true);
      }
    }
  }, [initialData]);

  return (
    <>
      <InfoModal
        visible={isVisibleSuccesModal}
        onClose={() => {
          setIsVisibleSuccessModal(false);
        }}
        description="El acta se guardó con éxito."
      />
      <ModalCodigoQR
        visible={visibleModalQR}
        onClose={() => setVisibleModalQR(false)}
        crearActaCierre={(dataFrom) => {
          handleDataFromQR(dataFrom);
          setVisibleFormModalActaCierre(true);
        }}
        dataQr={dataQR}
      />
      <ModalFormularioActaCierre
        visible={visibleFormModalActaCierre}
        onClose={handleCloseModalActaCierre}
        initialDataNewActaCierre={dataFromQR}
        pagina = { 1 }
        pageSize = { 10 }
      />
      <Modal
        title={initialData ? 'Editar Acta inicio' : 'Agregar Acta inicio'}
        wrapClassName="modal-formulario-monitoreo"
        open={visible}
        width="90%"
        onCancel={() => {
          handleCancel();
          setReasonCancel(false);
        }}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { marginLeft: '-1em' }, loading: isLoading }}
        okText={initialData ? 'Guardar' : 'Generar monitoreo'}
        onOk={handleOK}>
        <div>
          <LoadingCard visible={isLoading} />
          <div>
            <span className="folio-moni">
              Folio de monitoreo:{' '}
              <span className="value-folio">{initialData?.tableRow?.actas[0]?.folioMonitoreo}</span>
            </span>
          </div>
          <div className="modal-formulario-subtitulo">
            <span className="modal-formulario-subtitulo-descripcion">
              Captura la información solicitada.
            </span>
            <span className="modal-formulario-subtitulo-requeridos">*Campos obligatorios.</span>
          </div>
          <Form layout="vertical" form={formActaInicio}>
            <Row justify="start" align="top" gutter={[16, 0]}>
              <div className="container-procesoElec-status">
                <div className="proceso-electoral">
                  <Form.Item
                    label="Proceso Electoral:"
                    required
                    name="idProcesoGral"
                    rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}
                    style={{ width: '20em', margin: '1em 0' }}>
                    <Select
                      options={procesosElectorales}
                      placeholder="Selecciona el Proceso Electoral"
                      fieldNames={{
                        value: 'idProcesoElectoral',
                        label: 'descripcion'
                      }}
                      disabled={initialData?.tableRow?.actas[0]?.folioMonitoreo}
                    />
                  </Form.Item>
                </div>
                <div>
                  {initialData && (
                    <EstatusFormulario
                      reasonCancel={reasonCancel}
                      setReasonCancel={setReasonCancel}
                    />
                  )}
                </div>
              </div>
            </Row>
          </Form>
          <Accordion
            items={items}
            activeKey={activeKey}
            onChange={handleCollapseChange}
            className="modal-formulario-secciones"
          />
        </div>
      </Modal>
    </>
  );
};

export default ModalFormularioActaInicio;

ModalFormularioActaInicio.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  initialData: PropTypes.shape({
    tableRow: PropTypes.shape({
      actas: PropTypes.arrayOf(
        PropTypes.shape({
          folioMonitoreo: PropTypes.string,
          fiscalizacion: PropTypes.arrayOf(PropTypes.shape({}))
        })
      ),
      formatos: PropTypes.arrayOf(
        PropTypes.shape({
          idFormato: number,
          beneficiados: PropTypes.arrayOf(PropTypes.shape({}))
        })
      )
    })
  }),
  loadingImages: PropTypes.bool,
  filtroFolioActaInicio: PropTypes.string
};

ModalFormularioActaInicio.defaultProps = {
  visible: true,
  initialData: null,
  loadingImages: false,
  filtroFolioActaInicio: null
};
